import { createRouter, createWebHistory } from "vue-router";
import DailyTimelapseView from "@/views/camera/DailyTimelapseView.vue";
import GalleryView from "@/views/camera/GalleryView.vue";
import LiveView from "@/views/camera/LiveView.vue";
import ProjectTimelapseView from "@/views/camera/ProjectTimelapseView.vue";

const routes = [
  {
    path: "/:customer_name/:site_id/:camera_id/live",
    name: "LiveView",
    component: LiveView,
  },
  {
    path: "/:customer_name/:site_id/:camera_id/gallery",
    name: "GalleryView",
    component: GalleryView,
  },
  {
    path: "/:customer_name/:site_id/:camera_id/daily_timelapse",
    name: "DailyTimelapseView",
    component: DailyTimelapseView,
  },
  {
    path: "/:customer_name/:site_id/:camera_id/project_timelapse",
    name: "ProjectTimelapseView",
    component: ProjectTimelapseView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
